import type { GetPositionsParams } from '../services/interfaces/positions.types';

export const POSITIONS_QUERY_KEY_PREFIX = 'my-positions';

export const PositionsQueryKeys = {
  POSITIONS: (params?: Omit<GetPositionsParams, 'offset' | 'limit'>) => [
    POSITIONS_QUERY_KEY_PREFIX,
    'positions',
    params?.status,
  ],
  POSITION_DETAIL: (positionId: string) => [
    POSITIONS_QUERY_KEY_PREFIX,
    'position-detail',
    positionId,
  ],
} as const;
